import './Skeleton.scss';

const Skeleton = ({ type = 'row', width, height, style }) => (
  <div className={`skeleton skeleton--${type}`} style={{ width, height, ...style }} />
);

export default Skeleton;
